/**
 * Gera um token único para confirmação de presença usando Web Crypto API
 */
export async function generateConfirmationToken(guestId: string, eventId: string): Promise<string> {
  const data = `${guestId}-${eventId}-${Date.now()}`
  const encoder = new TextEncoder()
  const dataBuffer = encoder.encode(data)

  // Usar Web Crypto API que funciona no browser
  const hashBuffer = await crypto.subtle.digest("SHA-256", dataBuffer)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("")

  return hashHex.substring(0, 32)
}

/**
 * Gera um link único de confirmação para o convidado
 */
export async function generateConfirmationLink(
  phone: string,
  guestId: string,
  eventId: string,
  siteUrl: string,
): Promise<string> {
  const token = await generateConfirmationToken(guestId, eventId)
  const cleanPhone = phone.replace(/\D/g, "")

  return `${siteUrl}/eventos?phone=${cleanPhone}&token=${token}`
}

/**
 * Gera link para lista de presentes
 */
export function generateGiftListLink(siteUrl: string): string {
  return `${siteUrl}/lista-de-presentes`
}

/**
 * Valida um token de confirmação
 */
export function validateConfirmationToken(token: string): boolean {
  // Validação básica do formato do token
  return /^[a-f0-9]{32}$/.test(token)
}

/**
 * Extrai informações do token (se necessário para validações mais complexas)
 */
export function parseConfirmationToken(token: string): { isValid: boolean } {
  return {
    isValid: validateConfirmationToken(token),
  }
}
